import { useQuery } from '@tanstack/react-query';
import { extendedStatisticsApi } from '../api/extendedStatistics.api';
import { useCompany } from '@/contexts/CompanyContext';
import { useDirection } from '@/contexts/DirectionContext';
import type { ExtendedStatistics } from '../interfaces/extendedStatistics.interface';

interface UseExtendedStatisticsResult {
  data: ExtendedStatistics | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  refresh: () => void;
}

/**
 * Fetch-uiește statisticile pentru cele 4 stat-cards din dashboard nou.
 * Backend-ul filtrează după accountId din JWT; cheia query-ului include
 * selectedCompanyId ca să refacă fetch-ul când userul comută firma
 * (filtrarea reală pe companyId va fi adăugată în endpoint într-un pas viitor).
 */
export function useExtendedStatistics(): UseExtendedStatisticsResult {
  const { selectedCompanyId } = useCompany();
  const { direction } = useDirection();
  const companyId = typeof selectedCompanyId === 'number' ? selectedCompanyId : undefined;

  const query = useQuery<ExtendedStatistics>({
    queryKey: ['dashboard', 'extended-statistics', selectedCompanyId, direction],
    queryFn: () => extendedStatisticsApi.get(companyId, direction),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: (query.error as Error) || null,
    refresh: () => {
      void query.refetch();
    },
  };
}
